import axiosInstance from '../axios/axios-instance';
import { SignedTileDto } from 'shared/dto/project/signed-tile.dto';
import { TileClickResponseDto } from 'shared/enums/project/tile-click-response.dto';

export const project = {
  /**
   * Builds a signed browser-navigation URL. The backend resolves it to the
   * partner entry link with an HTTP redirect, allowing installed PWAs to hand
   * the navigation to the device browser from the original user gesture.
   */
  getEntryLaunchUrl(tileClickResponseDto: TileClickResponseDto, isProfileSurvey: boolean): string {
    if (!tileClickResponseDto.redirectUrl || !tileClickResponseDto.tileDetailsDto || !tileClickResponseDto.signature) {
      return '';
    }

    const launchUrl = new URL(tileClickResponseDto.redirectUrl, window.location.origin);
    launchUrl.searchParams.set('tileDetailsDto', tileClickResponseDto.tileDetailsDto);
    launchUrl.searchParams.set('signature', tileClickResponseDto.signature);
    launchUrl.searchParams.set('isProfileSurvey', isProfileSurvey.toString());

    return launchUrl.toString();
  },

  /**
   * Sends a tile click event to the backend.
   * @param signedTileDto The signed tile data.
   * @returns A promise that resolves to the result of the tile click.
   */
  async sendTileClick(
    signedTileDto: SignedTileDto,
    verisoulSessionId?: string,
    reinitializeSession?: () => Promise<void>
  ): Promise<TileClickResponseDto> {
    const response = await axiosInstance.post<TileClickResponseDto>('/click/tile-click', signedTileDto, {
      headers: {
        'x-rewardbloom-signature': signedTileDto.signature,
        'x-session-id': verisoulSessionId,
      },
    });

    if (response.headers['x-ip-changed']) {
      await reinitializeSession?.();
    }
    return response.data;
  },

  /**
   * Sends a POST request to the redirect URL with the signed tile data and retrieves the destination URL.
   * @param redirectUrl The URL where the request should be sent.
   * @param signedTileDto The signed tile data.
   * @returns A promise that resolves to the redirect destination URL.
   */
  async fetchEntryUrl(tileClickResponseDto: TileClickResponseDto): Promise<string> {
    const response = await axiosInstance.post<{ entryUrl: string }>(
      tileClickResponseDto.redirectUrl!,
      tileClickResponseDto,
      {
        headers: {
          'x-rewardbloom-signature': tileClickResponseDto.signature,
        },
      }
    );
    return response.data.entryUrl;
  },
};
